import React, { useContext } from 'react';
import Popover from '../Popover/Popover.es.js';
import { PopoverContext } from '../Popover/PopoverContext.es.js';
import { List } from '../List/List.es.js';
import { forwardRef } from '../../system/forwardRef.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const DropdownMenuComponent = (_a) => {
  var _b = _a, { children } = _b, props = __objRest(_b, ["children"]);
  return /* @__PURE__ */ React.createElement(Popover, __spreadValues({}, props), children);
};
DropdownMenuComponent.displayName = "DropdownMenu";
const DropdownMenuTrigger = ({ children }) => {
  return /* @__PURE__ */ React.createElement(Popover.Trigger, null, children);
};
const DropdownMenuList = forwardRef((_c, ref) => {
  var _d = _c, { children } = _d, rest = __objRest(_d, ["children"]);
  return /* @__PURE__ */ React.createElement(Popover.Content, __spreadValues({
    px: 0,
    py: "xs"
  }, rest), /* @__PURE__ */ React.createElement(List, {
    ref
  }, children));
});
const DropdownMenuItem = forwardRef((_e, ref) => {
  var _f = _e, { children, onClick, closeOnClick = true } = _f, props = __objRest(_f, ["children", "onClick", "closeOnClick"]);
  const { close } = useContext(PopoverContext);
  const handleClick = (event) => {
    closeOnClick && close();
    onClick == null ? void 0 : onClick(event);
  };
  return /* @__PURE__ */ React.createElement(List.Item, __spreadValues({
    ref,
    onClick: handleClick
  }, props), children);
});
DropdownMenuItem.displayName = "DropdownMenu.Item";
const DropdownMenu = Object.assign(DropdownMenuComponent, {
  Trigger: DropdownMenuTrigger,
  List: DropdownMenuList,
  Item: DropdownMenuItem,
  Icon: List.ItemIcon,
  SecondaryAction: List.ItemSecondaryAction,
  Divider: List.Divider
});
const ResponsiveMenu = Object.assign(DropdownMenuComponent, {
  Trigger: DropdownMenuTrigger,
  List: DropdownMenuList,
  Item: DropdownMenuItem,
  Icon: List.ItemIcon,
  SecondaryAction: List.ItemSecondaryAction,
  Divider: List.Divider
});

export { DropdownMenu, ResponsiveMenu };
//# sourceMappingURL=DropdownMenu.es.js.map
